import { useEffect, useMemo, useState } from 'react';
import Fade from '@mui/material/Fade';

import { tss } from 'tss-react/mui';

import { SvgIcon } from '@mui/material';

import defaultLogoAddr from 'Images/GHSIdebarLogo.svg';
import { env } from '@/env';

import { Or2Image } from '../image/Or2Image';
interface Props {
  defaultSrc?: string;
  logoSrc?: string;
  width?: number;
  height?: number;
}
const useStyles = tss.create(() => ({
  image: {
    position: 'absolute',
  },
}));

export const Logo: React.FC<Props> = ({
  defaultSrc = defaultLogoAddr,
  logoSrc = env.NEXT_PUBLIC_CURRENT_LOGO_PATH,
  width = 224,
  height = 60,
}) => {
  const { classes } = useStyles();
  const [loaded, setLoaded] = useState(false);

  const logoUrl = useMemo(() => new URL(logoSrc ?? ''), [logoSrc]);

  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      setLoaded(true);
    };
    img.src = logoUrl.toString();
  }, [logoUrl]);

  return (
    <div style={{ position: 'relative', width, height }}>
      <Fade in={!loaded} timeout={1000} appear={false}>
        <SvgIcon
          component={defaultSrc}
          className={classes.image}
          alt={env.NEXT_PUBLIC_SITE_NAME}
          width={width}
          height={height}
          sx={{
            width: '100%',
            height: '100%',
          }}
          viewBox="208 0 32 120"
        />
      </Fade>
      <Fade in={loaded} timeout={1000}>
        <Or2Image
          className={classes.image}
          src={logoUrl.toString()}
          alt={env.NEXT_PUBLIC_SITE_NAME}
          width={width}
          height={height}
        />
      </Fade>
    </div>
  );
};
